<template>
  <div v-if="!hideBrand" class="swaychat-powered">
    <h6>{{ getLang.powered_by }}
      <a href="http://swaychat.com" target="_&quot;blank&quot;">
        <span>Swaychat</span>
      </a>
    </h6>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    computed: {
      ...mapGetters([
        'getLang',
        'hideBrand'
      ])
    }
}
</script>
